import request from '../axios'
import requestSec from '../axiosSec'

// 档案库
// 成员列表数据
export const archivetargetmemberList = params => request({
	url: 'archive/archivetargetmember/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		key: params.key ? encodeURIComponent(params.key) : ''
	}
})

// 成员/综合档案--材料列表
export const archivetargetmemberListInfo = params => request({
	url: 'archive/archivetargetmember/list/info',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260401修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 成员档案下载
export const downloadMember = params => request({
	url: 'archive/archivetargetmember/download/member',
	method: 'get',
	params: params,
	responseType: 'blob'
})

// 成员档案--移除
export const archivetargetmemberRemove = params => request({
	url: 'archive/archivetargetmember/remove',
	method: 'get',
	params: params
})

// 成员档案--移动
export const archivetargetmemberMove = params => request({
	url: 'archive/archivetargetmember/move',
	method: 'get',
	params: params
})

// 获取当前成员信息
export const archivetargetmemberInfo = params => request({
	url: 'archive/archivetargetmember/info/' + params.id,
	method: 'get'
})

// 综合档案--获取项目
export const archivetargetoverallList = params => request({
	url: 'archive/archivetargetoverall/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		name: params.name ? encodeURIComponent(params.name) : ''
	}
})

// 综合档案--根据项目--获取信息
export const archivetargetoverallGetBaseInfo = params => request({
	url: 'archive/archivetargetoverall/getBaseInfo/' + params.id,
	method: 'get'
})

// 获取档案成员（全部--管理员）
export const archivetargetoverallmemberList = params => request({
	url: 'archive/archivetargetoverallmember/list',
	method: 'get',
	params: params
})

// 获取档案成员（部门等树形结构）
export const archivetargetoverallGetMemberCanAdd = params => request({
	url: 'archive/archivetargetoverall/getMemberCanAdd',
	method: 'get',
	params: params
})

// 综合档案下载
export const downloadOveral = params => request({
	url: 'archive/archivetargetmember/download/overall',
	method: 'get',
	params: params,
	responseType: 'blob'
})

// 综合档案--移动
export const archivetargetoverallMove = params => request({
	url: 'archive/archivetargetoverall/move',
	method: 'get',
	params: params
})

// 获取全部档案阶段
export const archivestageAllStage = params => request({
	url: 'archive/archivestage/allStage',
	method: 'get',
	params: params
})

// 综合档案--新建材料--获取材料类型列表
export const archiverecordtypeAllType = params => request({
	url: 'archive/archiverecordtype/allType',
	method: 'get',
	params: params
})

// 获取全部设备类别
export const archivedevicetypeListAll = params => request({
	url: 'archive/archivedevicetype/listAll',
	method: 'get',
	params: params
})

// 获取设备列表
export const archivedeviceList = params => request({
	url: 'archive/archivedevice/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 设备登记--导出
export const archivedeviceDownload = data => request({
	url: 'archive/archivedevice/download',
	method: 'post',
	data,
	responseType: 'blob'
})

// 设备详情--导出当前设备信息/申请/维护记录
export const downloadApplyMaintain = params => request({
	url: 'archive/archivedevice/download/applyMaintain/' + params.id,
	method: 'get',
	responseType: 'blob'
})

// 获取时间区间和档案类别数据（每次切换时间区间，档案类别就需要重置到全部）
export const archiverecordGetTimeAndType = params => request({
	url: 'archive/archiverecord/getTimeAndType',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 到期预警列表
export const archiverecordMaturityWarning = params => request({
	url: 'archive/archiverecord/maturityWarning',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260312修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 到期预警--续期
export const archiverecordRenewal = data => request({
	url: 'archive/archiverecord/renewal',
	method: 'post',
	data: data,
})

// 到期预警下载
export const archiverecordDownload = data => request({
	url: 'archive/archiverecord/download',
	method: 'post',
	data: data,
	responseType: 'blob'
})

// 获取档案配置
export const configarchiveInfo = params => request({
	url: 'config/configarchive/info',
	method: 'get',
	params: params
})

// 获取档案配置
export const archivetargetoverallServiceCompany = params => request({
	url: 'archive/archivetargetoverall/serviceCompany/' + params.id,
	method: 'get'
})

// 新增综合档案
export const archivetargetoverallAddOverall = data => request({
	url: 'archive/archivetargetoverall/addOverall',
	method: 'post',
	data: data,
})

// 编辑综合档案
export const archivetargetoverallUpdateBaseInfo = data => request({
	url: 'archive/archivetargetoverall/updateBaseInfo',
	method: 'post',
	data: data,
})

// 删除综合档案
export const archivetargetoverallDelete = data => request({
	url: 'archive/archivetargetoverall/delete',
	method: 'post',
	data: data,
})

// 新增服务商信息（返回ID用于保存）
export const syscompanyorganizationSaveCompanyOrganizationForOverall = data => request({
	url: 'sys/syscompanyorganization/saveCompanyOrganizationForOverall',
	method: 'post',
	data: data,
})

// 编辑服务商信息（返回ID用于保存）
export const syscompanyorganizationUpdateCompanyOrganizationForOveral = data => request({
	url: 'sys/syscompanyorganization/updateCompanyOrganizationForOverall',
	method: 'post',
	data: data,
})

// 新建/追加材料--成员/综合档案
export const archiverecordAddMaterial = data => request({
	url: 'archive/archiverecord/addMaterial',
	method: 'post',
	data: data,
})

// 删除材料--成员/综合档案（删除单页/所有）
export const archiverecordDelete = data => request({
	url: 'archive/archiverecord/delete',
	method: 'post',
	data: data,
})

// 删除材料--成员/综合档案列表
export const archiverecordDeleteMaterial = data => request({
	url: 'archive/archiverecord/deleteMaterial',
	method: 'post',
	data: data,
})

// 获取材料详细信息--成员/综合档案
export const archiverecordDetails = data => request({
	url: 'archive/archiverecord/details',
	method: 'post',
	data: data,
})

// 材料翻页--成员/综合档案
export const archiverecordNextPage = data => request({
	url: 'archive/archiverecord/nextPage',
	method: 'post',
	data: data,
})

// 编辑材料--成员/综合档案
export const archiverecordUpdateMaterial = data => request({
	url: 'archive/archiverecord/updateMaterial',
	method: 'post',
	data: data,
})

// 获取设备详情
export const archivedeviceInfo = params => request({
	url: 'archive/archivedevice/info/' + params.id,
	method: 'get'
})

// 设备申请
export const archivedeviceapplyApply = data => request({
	url: 'archive/archivedeviceapply/apply',
	method: 'post',
	data: data,
})

// 设备审批（设备申请）列表
export const archivedeviceapplyList = params => request({
	url: 'archive/archivedeviceapply/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 设备审批（通过、否决）
export const archivedeviceapplyAuthorize = data => request({
	url: 'archive/archivedeviceapply/authorize',
	method: 'post',
	data: data,
})

// 设备审批申请详情
export const archivedeviceapplyInfo = params => request({
	url: 'archive/archivedeviceapply/info/' + params.id,
	method: 'get'
})

// 设备详情维修记录
export const archivedevicemaintainList = params => request({
	url: 'archive/archivedevicemaintain/list',
	method: 'get',
	params: params
})

// 新增设备维护
export const archivedevicemaintainAddMaintain = data => request({
	url: 'archive/archivedevicemaintain/addMaintain',
	method: 'post',
	data: data,
})

// 设备申请批量删除
export const archivedeviceapplyDelete = data => request({
	url: 'archive/archivedeviceapply/delete',
	method: 'post',
	data: data,
})

// 设备维护批量删除
export const archivedevicemaintainDelete = data => request({
	url: 'archive/archivedevicemaintain/delete',
	method: 'post',
	data: data,
})

// 新增设备
export const archivedeviceAddDevice = data => request({
	url: 'archive/archivedevice/addDevice',
	method: 'post',
	data: data,
})

// 编辑设备
export const archivedeviceUpdateDevice = data => request({
	url: 'archive/archivedevice/updateDevice',
	method: 'post',
	data: data,
})

// 删除/批量删除设备
export const archivedeviceDelete = data => request({
	url: 'archive/archivedevice/delete',
	method: 'post',
	data: data,
})

// 获取当前集团全部人员树形结构
export const sysdepartmentListByCompany = params => request({
	url: 'sys/sysdepartment/listByCompany',
	method: 'get',
	params: params
})

// 设置默认档案阶段、服务商
export const configarchiveSetDefaultDeploy = data => request({
	url: 'config/configarchive/setDefaultDeploy',
	method: 'post',
	data: data,
})

// 获取运行状态（只有五个状态）
export const archivedeviceRunState = params => request({
	url: 'archive/archivedevice/runState',
	method: 'get',
	params: params
})

// 设置触发预警
export const configarchiveSetTouchWarning = data => request({
	url: 'config/configarchive/setTouchWarning',
	method: 'post',
	data: data,
})

// 新增档案阶段
export const archivestageAddStage = data => request({
	url: 'archive/archivestage/addStage',
	method: 'post',
	data: data,
})

// 编辑档案阶段
export const archivestageUpdateStage = data => request({
	url: 'archive/archivestage/updateStage',
	method: 'post',
	data: data,
})

// 新增材料类型
export const archiverecordtypeAddType = data => request({
	url: 'archive/archiverecordtype/addType',
	method: 'post',
	data: data,
})

// 编辑材料类型
export const archiverecordtypeUpdateType = data => request({
	url: 'archive/archiverecordtype/updateType',
	method: 'post',
	data: data,
})

// 初始化预警内容数据
export const configarchiveInitWarningContent = params => request({
	url: 'config/configarchive/initWarningContent',
	method: 'get',
	params: params
})

// 预警内容设置
export const configarchiveSetWarningContent = data => request({
	url: 'config/configarchive/setWarningContent',
	method: 'post',
	data: data,
})

// 设置导出许可状态
export const configarchiveSetExportStatus = data => request({
	url: 'config/configarchive/setExportStatus',
	method: 'post',
	data: data,
})

// 档案配置--删除档案阶段
export const archivestageDeleteStage = data => request({
	url: 'archive/archivestage/deleteStage',
	method: 'post',
	data: data,
})

// 档案配置--删除材料类型
export const archiverecordtypeDeleteType = data => request({
	url: 'archive/archiverecordtype/deleteType',
	method: 'post',
	data: data,
})

// 档案配置--删除设备类型
export const archivedevicetypeDelete = data => request({
	url: 'archive/archivedevicetype/delete',
	method: 'post',
	data: data,
})

// 档案配置--新增设备类型
export const archivedevicetypeSave = data => request({
	url: 'archive/archivedevicetype/save',
	method: 'post',
	data: data,
})

// 档案配置--编辑设备类型
export const archivedevicetypeUpdate = data => request({
	url: 'archive/archivedevicetype/update',
	method: 'post',
	data: data,
})

// 档案配置--设备类型--拖动排序
export const archivedevicetypeSortType = data => request({
	url: 'archive/archivedevicetype/sortType',
	method: 'post',
	data: data,
})

// 成员档案下载
export const archivetargetmemberDownloadMemberCustomize = data => request({
	url: 'archive/archivetargetmember/download/member/customize',
	method: 'post',
	data: data,
	responseType: 'blob'
})

// 综合档案下载
export const archivetargetmemberDownloadOverallCustomize = data => request({
	url: 'archive/archivetargetmember/download/overall/customize',
	method: 'post',
	data: data,
	responseType: 'blob'
})

// 设备登记导出
export const archivedeviceDownloadCustomize = data => request({
	url: 'archive/archivedevice/download/customize',
	method: 'post',
	data: data,
	responseType: 'blob'
})

// 设备审批导出
export const archivedeviceapplyDownloadCustomize = data => request({
	url: 'archive/archivedeviceapply/download/customize',
	method: 'post',
	data: data,
	responseType: 'blob'
})

// 获取状态为审批中的个数
export const archivedeviceapplyApprovalNum = params => request({
	url: 'archive/archivedeviceapply/approvalNum',
	method: 'get',
	params: params
})

// 根据档案ID获取其所在分页
export const archivetargetmemberGetMemberWhere = params => request({
	url: 'archive/archivetargetmember/getMemberWhere',
	method: 'get',
	params: params
})

// 修改设备审批结果推送
export const configarchiveUpdateDeviceApprovalResult = data => request({
	url: 'config/configarchive/updateDeviceApprovalResult',
	method: 'post',
	data: data
})

// 档案设置--档案阶段（批量）
export const archivestageUpdateStageBatch = data => request({
	url: 'archive/archivestage/updateStageBatch',
	method: 'post',
	data: data
})

// 档案设置--材料类型（批量）
export const archiverecordtypeUpdateTypeBatch = data => request({
	url: 'archive/archiverecordtype/updateTypeBatch',
	method: 'post',
	data: data
})

// 档案设置--设备类型（批量）
export const archivedevicetypeUpdateBatch = data => request({
	url: 'archive/archivedevicetype/updateBatch',
	method: 'post',
	data: data
})

// 检查成员档案是否被删除
export const archiverecordCheckUserArchive = data => request({
	url: 'archive/archiverecord/checkUserArchive',
	method: 'post',
	data: data
})

// 到期预警导出前置查询
export const archiverecordDownloadWaring = data => request({
	url: 'archive/archiverecord/downloadWaring',
	method: 'post',
	data: data
})
